<template>
  <div class="flex opacity-70 sm:hidden">
    <Button
      @click="updateValue('left')"
      size="sm"
      variant="tertiary"
      :disabled="modelValue === 'left'"
      class="w-full !p-[10px] rounded-r-none border-r-transparent !border-gpx_black-50 !bg-black !text-gpx_gray-100 hover:!opacity-80 disabled:!border-gpx_black-50 disabled:!bg-gpx_black-50 disabled:!text-white"
    >
      <ListBulletIcon class="h-[18px]" />
    </Button>
    <Button
      @click="updateValue('center')"
      size="sm"
      variant="tertiary"
      :disabled="modelValue === 'center'"
      class="w-full !p-[10px] rounded-l-none border-l-transparent -translate-x-px !border-gpx_black-50 !bg-black !text-gpx_gray-100 hover:!opacity-80 disabled:!border-gpx_black-50 disabled:!bg-gpx_black-50 disabled:!text-white"
      :class="{
        'rounded-r-none': $can('use', 'Ai'),
        'border-r-transparent': $can('use', 'Ai'),
      }"
    >
      <MapIcon class="h-[18px]" />
    </Button>
    <Button
      v-if="$can('use', 'Ai')"
      @click="updateValue('right')"
      size="sm"
      variant="tertiary"
      :disabled="modelValue === 'right'"
      class="w-full !p-[10px] rounded-l-none border-l-transparent -translate-x-[2px] !border-gpx_black-50 !bg-black !text-gpx_gray-100 hover:!opacity-80 disabled:!border-gpx_black-50 disabled:!bg-gpx_black-50 disabled:!text-white"
    >
      <MapPinIcon class="h-[18px]" />
    </Button>
  </div>
</template>

<script setup>
import { ListBulletIcon, MapIcon, MapPinIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  modelValue: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (value) => {
  emit('update:modelValue', value);
};
</script>
